import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import {
    fetchAllData,
    fetchData,
    fetchUpdateData,
} from "../../helpers/externapi";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Layout from "../../Layout/Layout";
import PageWrapper from "../../Components/PageWrapper";

export default function DoctorManagement() {
    const navigate = useNavigate();
    const params = useParams();
    const { Id: hospitalId, doctorId } = useParams();


    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [doctorServices, setDoctorServices] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [doctorErrors, setDoctorErrors] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);

    const UserId = localStorage.getItem("UserId");

    // Default time state for quick setting
    const [defaultTime, setDefaultTime] = useState({
        startTime: '',
        endTime: ''
    });

    const [doctorDetails, setDoctorDetails] = useState({
        FullName: "",
        MobileNumber: "",
        DateofBirth: "",
        Age: "",
        Email: "",
        Address: "",
        Qualification: "",
        Services: [],
        doctorId: "",
        DoctorServicesProvisionId: "",
        timings: [
            {
                scheduleDate: "",
                startTime: "",
                endTime: "",
                isActive: true
            }
        ]
    });



    // Enhanced weekly schedule state with availability types
    const [weekSchedule, setWeekSchedule] = useState({
          Sunday: {
            availabilityType: 'unavailable',
            timings: [],
            unavailableTimings: [],
            reason: ''
        },
        Monday: {
            availabilityType: 'unavailable', // 'available', 'unavailable', 'partial_unavailable'
            timings: [],
            unavailableTimings: [],
            reason: ''
        },
        Tuesday: {
            availabilityType: 'unavailable',
            timings: [],
            unavailableTimings: [],
            reason: ''
        },
        Wednesday: {
            availabilityType: 'unavailable',
            timings: [],
            unavailableTimings: [],
            reason: ''
        },
        Thursday: {
            availabilityType: 'unavailable',
            timings: [],
            unavailableTimings: [],
            reason: ''
        },
        Friday: {
            availabilityType: 'unavailable',
            timings: [],
            unavailableTimings: [],
            reason: ''
        },
        Saturday: {
            availabilityType: 'unavailable',
            timings: [],
            unavailableTimings: [],
            reason: ''
        }
      
    });

    const daysOfWeek = [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const [selectedDays, setSelectedDays] = useState(new Set());

    // Function to get date for a specific day of current week
    const getDateForDay = (dayName) => {
        const today = new Date();
        const currentDay = today.getDay();
        const dayMap = {
            'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3,
            'Thursday': 4, 'Friday': 5, 'Saturday': 6
        };

        const targetDay = dayMap[dayName];
        const diff = targetDay - currentDay;
        const targetDate = new Date(today);
        targetDate.setDate(today.getDate() + diff);

        return targetDate.toISOString().split('T')[0];
    };

    // Convert weekly schedule to timings payload with multiple entries
    const convertWeekScheduleToTimings = () => {
        const timings = [];

        Object.keys(weekSchedule).forEach(day => {
            const dayData = weekSchedule[day];
            const scheduleDate = getDateForDay(day);

            if (dayData.availabilityType === 'unavailable') {
                // Doctor is on leave - send isActive: false
                timings.push({
                    scheduleDate: scheduleDate,
                    isActive: false,
                    timingId: dayData.timingId || undefined,
                    Reason: dayData.reason || null
                });
            } else if (dayData.availabilityType === 'available' && dayData.timings.length > 0) {
                // Doctor is available - send regular working hours
                const timing = dayData.timings[0];
                if (timing.startTime && timing.endTime) {
                    timings.push({
                        scheduleDate: scheduleDate,
                        startTime: timing.startTime,
                        endTime: timing.endTime,
                        isActive: true,
                        timingId: timing.timingId || undefined
                    });
                }
            } else if (dayData.availabilityType === 'partial_unavailable') {
                // Doctor has both available and unavailable times
                if (dayData.timings.length > 0) {
                    const timing = dayData.timings[0];
                    if (timing.startTime && timing.endTime) {
                        timings.push({
                            scheduleDate: scheduleDate,
                            startTime: timing.startTime,
                            endTime: timing.endTime,
                            isActive: true,
                            timingId: timing.timingId || undefined
                        });
                    }
                }

                // Add unavailable time slots
                if (dayData.unavailableTimings.length > 0) {
                    const unavailableTiming = dayData.unavailableTimings[0];
                    if (unavailableTiming.startTime && unavailableTiming.endTime) {
                        timings.push({
                            scheduleDate: scheduleDate,
                            unavailableStartTime: unavailableTiming.startTime,
                            unavailableEndTime: unavailableTiming.endTime,
                            isActive: true,
                            timingId: unavailableTiming.timingId || undefined
                        });
                    }
                }
            }
        });

        return timings;
    };

    // Convert timings array to weekly schedule format (enhanced for new structure)
    const convertTimingsToWeekSchedule = (timings) => {
        const schedule = {
            Sunday: { availabilityType: 'unavailable', timings: [], unavailableTimings: [], reason: '' },
            Monday: { availabilityType: 'unavailable', timings: [], unavailableTimings: [], reason: '' },
            Tuesday: { availabilityType: 'unavailable', timings: [], unavailableTimings: [], reason: '' },
            Wednesday: { availabilityType: 'unavailable', timings: [], unavailableTimings: [], reason: '' },
            Thursday: { availabilityType: 'unavailable', timings: [], unavailableTimings: [], reason: '' },
            Friday: { availabilityType: 'unavailable', timings: [], unavailableTimings: [], reason: '' },
            Saturday: { availabilityType: 'unavailable', timings: [], unavailableTimings: [], reason: '' }
        };

        // Group timings by date
        const timingsByDate = {};
        timings.forEach(timing => {
            const date = timing.scheduleDate;
            if (!timingsByDate[date]) {
                timingsByDate[date] = [];
            }
            timingsByDate[date].push(timing);
        });

        // Process each date
        Object.keys(timingsByDate).forEach(dateStr => {
            const date = new Date(dateStr);
            const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const dayName = dayNames[date.getDay()];

            if (schedule[dayName]) {
                const dayTimings = timingsByDate[dateStr];

                // Check if doctor is on leave
                const leaveEntry = dayTimings.find(t => t.isActive === false);
                if (leaveEntry) {
                    schedule[dayName].availabilityType = 'unavailable';
                    schedule[dayName].timingId = leaveEntry.timingId;
                    schedule[dayName].reason = leaveEntry.reason || ''; // Add reason
                    return;
                }

                // Check for regular availability and unavailable periods
                const availableEntry = dayTimings.find(t => t.startTime && t.endTime);
                const unavailableEntry = dayTimings.find(t => t.unavailableStartTime && t.unavailableEndTime);

                if (availableEntry && unavailableEntry) {
                    // Both available and unavailable times
                    schedule[dayName].availabilityType = 'partial_unavailable';
                    schedule[dayName].timings = [{
                        startTime: availableEntry.startTime,
                        endTime: availableEntry.endTime,
                        timingId: availableEntry.timingId
                    }];
                    schedule[dayName].unavailableTimings = [{
                        startTime: unavailableEntry.unavailableStartTime,
                        endTime: unavailableEntry.unavailableEndTime,
                        timingId: unavailableEntry.timingId
                    }];
                } else if (availableEntry) {
                    // Only available times
                    schedule[dayName].availabilityType = 'available';
                    schedule[dayName].timings = [{
                        startTime: availableEntry.startTime,
                        endTime: availableEntry.endTime,
                        timingId: availableEntry.timingId
                    }];
                }
            }
        });

        return schedule;
    };

    // Sync weekly schedule changes with doctorDetails.timings
    useEffect(() => {
        const updatedTimings = convertWeekScheduleToTimings();
        setDoctorDetails(prev => ({
            ...prev,
            timings: updatedTimings
        }));
    }, [weekSchedule]);

    // Fetch doctor services on component mount
    useEffect(() => {
        const getDoctorServices = async () => {
            try {
                setLoading(true);
                const doctorServices = await fetchData("HospitalServices/all", {
                    skip: 0,
                    take: 0,
                });

                const activeServices = doctorServices.filter((item) => item.IsActive);
                const doctorServicesArray = activeServices.map((item) => ({
                    label: item.ServiceName,
                    value: item.HospitalServicesId,
                }));

                setDoctorServices(doctorServicesArray);
            } catch (error) {
                console.error("Error fetching doctor services:", error);
            } finally {
                setLoading(false);
            }
        };

        getDoctorServices();
    }, []);

    // Check if it's edit mode and fetch existing doctor
    useEffect(() => {
        if (doctorId) {
            setIsEditMode(true);
            fetchExistingDoctor();
        }
    }, [doctorId]);

    const fetchExistingDoctor = async () => {
        try {
            setLoading(true);
            const doctorResponse = await fetchAllData(`Doctor/GetById/${doctorId}`);

            if (doctorResponse[0]) {
                const doctorServicesList = doctorResponse[0].DoctorSpecialization?.map(
                    (specialization) => ({
                        value: specialization.HospitalServicesId,
                        label: specialization.ServiceName.trim(),
                    })
                ) || [];

                setDoctorDetails({
                    FullName: doctorResponse[0].FullName || "",
                    MobileNumber: doctorResponse[0].MobileNumber || "",
                    DateofBirth: doctorResponse[0].DateofBirth
                        ? doctorResponse[0].DateofBirth.split("T")[0]
                        : "",
                    Age: doctorResponse[0].Age || "",
                    Email: doctorResponse[0].Email || "",
                    Address: doctorResponse[0].Address || "",
                    Qualification: doctorResponse[0].Qualification || "",
                    Services: doctorServicesList,
                    doctorId: doctorResponse[0].DoctorId,
                    DoctorServicesProvisionId: doctorServicesList.map(
                        (service) => service.id
                    ),
                    timings: []
                });

                // Fetch timings for the doctor
                await fetchDoctorTimings(doctorResponse[0].DoctorId);
            }
        } catch (error) {
            console.error("Error fetching doctor data:", error);
            setSnackbarMessage("Error fetching doctor data");
            setSnackbarOpen(true);
        } finally {
            setLoading(false);
        }
    };

    const fetchDoctorTimings = async (doctorId) => {
    try {
        const today = new Date();

        // Get current week's Sunday
        const startDate = new Date(today);
        startDate.setDate(today.getDate() - today.getDay()); // Sunday

        // Get current week's Saturday
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6); // Saturday

        const timingResponse = await fetchData(
            'lambdaAPI/DoctorTimings/GetDoctorTimingsByDateRange',
            {
                doctorId: doctorId,
                startDate: startDate.toISOString().split('T')[0],
                endDate: endDate.toISOString().split('T')[0]
            }
        );

        if (timingResponse && timingResponse.length > 0) {
            const transformedTimings = timingResponse.map(timing => ({
                scheduleDate: timing.ScheduleDate.split('T')[0],
                startTime: timing.StartTime || "",
                endTime: timing.EndTime || "",
                unavailableStartTime: timing.UnavailableStartTime || "",
                unavailableEndTime: timing.UnavailableEndTime || "",
                isActive: timing.IsActive,
                timingId: timing.TimingId,
                dayOfWeek: timing.DayOfWeek,
                reason: timing.Reason || "",
            }));

            setDoctorDetails(prev => ({
                ...prev,
                timings: transformedTimings
            }));

            const weeklyScheduleData = convertTimingsToWeekSchedule(transformedTimings);
            setWeekSchedule(weeklyScheduleData);

            const daysSet = new Set();
            transformedTimings.forEach(timing => {
                if (timing.dayOfWeek) {
                    daysSet.add(timing.dayOfWeek);
                }
            });
            setSelectedDays(daysSet);
        }
    } catch (error) {
        console.error(`Error fetching timings for doctor ${doctorId}:`, error);
    }
};

    const calculateAge = (dob) => {
        const today = new Date();
        const birthDate = new Date(dob);
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const calculateDOBFromAge = (age) => {
        const today = new Date();
        return new Date(today.setFullYear(today.getFullYear() - age))
            .toISOString()
            .split("T")[0];
    };

    const handleInputChange = (field, value) => {
        const updatedDoctorDetails = { ...doctorDetails };

        if (field === "Age") {
            updatedDoctorDetails.Age = value;
            updatedDoctorDetails.DateofBirth = value
                ? calculateDOBFromAge(parseInt(value))
                : "";
        } else if (field === "DateofBirth") {
            updatedDoctorDetails.DateofBirth = value;
            updatedDoctorDetails.Age = value ? calculateAge(value) : "";
        } else {
            updatedDoctorDetails[field] = value;
        }

        setDoctorDetails(updatedDoctorDetails);
    };

    const handleServiceChange = (selectedServices) => {
        const updatedDoctorDetails = { ...doctorDetails };
        updatedDoctorDetails.Services = selectedServices.map((service) => ({
            ...service,
            DoctorServicesProvisionId: service.DoctorServicesProvisionId || null,
        }));
        setDoctorDetails(updatedDoctorDetails);
    };

    // Enhanced availability management functions
    const setDayAvailabilityType = (day, type) => {
        setWeekSchedule(prev => ({
            ...prev,
            [day]: {
                availabilityType: type,
                timings: type === 'available' || type === 'partial_unavailable' ? [{ startTime: '', endTime: '' }] : [],
                unavailableTimings: type === 'partial_unavailable' ? [{ startTime: '', endTime: '' }] : [],
                reason: type === 'unavailable' ? prev[day].reason || '' : '', // Preserve reason if switching to unavailable
                timingId: prev[day].timingId
            }
        }));
    };

    // Update available time slot
    const updateAvailableTimeSlot = (day, field, value) => {
        setWeekSchedule(prev => ({
            ...prev,
            [day]: {
                ...prev[day],
                timings: [{
                    ...prev[day].timings[0],
                    [field]: value
                }]
            }
        }));
    };

    // Update unavailable time slot
    const updateUnavailableTimeSlot = (day, field, value) => {
        setWeekSchedule(prev => ({
            ...prev,
            [day]: {
                ...prev[day],
                unavailableTimings: [{
                    ...prev[day].unavailableTimings[0],
                    [field]: value
                }]
            }
        }));
    };

    const updateUnavailableReason = (day, reason) => {
        setWeekSchedule(prev => ({
            ...prev,
            [day]: {
                ...prev[day],
                reason: reason
            }
        }));
    };

    // Clear day schedule
    const clearDaySchedule = (day) => {
        setWeekSchedule(prev => ({
            ...prev,
            [day]: {
                availabilityType: 'unavailable',
                timings: [],
                unavailableTimings: []
            }
        }));
    };

    const toggleDaySelection = (day) => {
        setSelectedDays(prev => {
            const newSet = new Set(prev);
            if (newSet.has(day)) {
                newSet.delete(day);
            } else {
                newSet.add(day);
            }
            return newSet;
        });
    };

    // Select all days
    const selectAllDays = () => {
        setSelectedDays(new Set(daysOfWeek));
    };

    // Clear all day selections
    const clearAllDays = () => {
        setSelectedDays(new Set());
    };

    // Apply default time to selected days only
    const applyDefaultToSelectedDays = () => {
        if (!defaultTime.startTime || !defaultTime.endTime || selectedDays.size === 0) return;

        setWeekSchedule(prev => {
            const updated = { ...prev };
            selectedDays.forEach(day => {
                if (updated[day].availabilityType === 'available' || updated[day].availabilityType === 'partial_unavailable') {
                    updated[day].timings = [{
                        startTime: defaultTime.startTime,
                        endTime: defaultTime.endTime,
                        timingId: updated[day].timings[0]?.timingId
                    }];
                }
            });
            return updated;
        });
    };

    // Make selected days available
    const makeSelectedDaysAvailable = () => {
        if (selectedDays.size === 0) return;

        setWeekSchedule(prev => {
            const updated = { ...prev };
            selectedDays.forEach(day => {
                updated[day] = {
                    availabilityType: 'available',
                    timings: [{ startTime: '', endTime: '' }],
                    unavailableTimings: [],
                    timingId: updated[day].timingId
                };
            });
            return updated;
        });
    };

    // Make selected days unavailable
    const makeSelectedDaysUnavailable = () => {
        if (selectedDays.size === 0) return;

        setWeekSchedule(prev => {
            const updated = { ...prev };
            selectedDays.forEach(day => {
                updated[day] = {
                    availabilityType: 'unavailable',
                    timings: [],
                    unavailableTimings: [],
                    timingId: updated[day].timingId
                };
            });
            return updated;
        });
    };


    const calculateDuration = (startTime, endTime) => {
        if (!startTime || !endTime) return '--';

        const start = new Date(`2000-01-01T${startTime}`);
        const end = new Date(`2000-01-01T${endTime}`);
        const diffMs = end - start;

        if (diffMs <= 0) return 'Invalid';

        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

        if (diffHours === 0) return `${diffMinutes}m`;
        if (diffMinutes === 0) return `${diffHours}h`;
        return `${diffHours}h ${diffMinutes}m`;
    };

    const validateDoctorBeforeSubmit = () => {
        const errors = {};

        if (!doctorDetails.FullName?.trim()) {
            errors.FullName = "Please Enter Doctor Name";
        }
        if (!doctorDetails.Qualification?.trim()) {
            errors.Qualification = "Please Enter Doctor Qualification";
        }
        if (!doctorDetails.Services || doctorDetails.Services.length === 0) {
            errors.Services = "At least one service must be selected";
        }
        if (!doctorDetails.MobileNumber?.trim()) {
            errors.MobileNumber = "Please Enter Mobile Number";
        } else if (!/^[6-9]\d{9}$/.test(doctorDetails.MobileNumber.trim())) {
            errors.MobileNumber = "Mobile Number must start with 6, 7, 8, or 9 and must be 10 digits";
        }

        setDoctorErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const onSubmitHandler = async (event) => {
        event.preventDefault();

        const isDoctorValid = validateDoctorBeforeSubmit();

        if (!isDoctorValid) {
            setSnackbarMessage("Please fix the validation errors");
            setSnackbarOpen(true);
            return;
        }

        try {
            setSubmitLoading(true);

            let doctorId;

            if (isEditMode) {
                // Update existing doctor
                const updatePayload = {
                    FullName: doctorDetails.FullName,
                    MobileNumber: doctorDetails.MobileNumber,
                    DateofBirth: doctorDetails.DateofBirth,
                    Age: doctorDetails.Age,
                    Email: doctorDetails.Email,
                    Address: doctorDetails.Address,
                    Qualification: doctorDetails.Qualification,
                    HospitalId: hospitalId,
                    DoctorId: doctorDetails.doctorId,
                    UpdatedBy: UserId,
                };

                const updatedDoctor = await fetchData("Doctor/seedUpdate", [updatePayload]);
                doctorId = doctorDetails.doctorId;
                setSnackbarMessage("Doctor updated successfully!");
            } else {
                // Create new doctor
                const createPayload = {
                    FullName: doctorDetails.FullName,
                    MobileNumber: doctorDetails.MobileNumber,
                    DateofBirth: doctorDetails.DateofBirth,
                    Age: doctorDetails.Age,
                    Email: doctorDetails.Email,
                    Address: doctorDetails.Address,
                    Qualification: doctorDetails.Qualification,
                    HospitalId: hospitalId,
                    CreatedBy: UserId,
                };

                const newDoctor = await fetchData("Doctor/seed", [createPayload]);
                doctorId = newDoctor[0].doctorId;
                setSnackbarMessage("Doctor added successfully!");
            }

            // Submit doctor services
            if (doctorDetails.Services && doctorDetails.Services.length > 0) {
                const doctorServicesData = doctorDetails.Services.map((service) => ({
                    DoctorId: doctorId,
                    CreatedBy: UserId,
                    HospitalServicesId: service.value,
                }));

                await fetchData("DoctorServicesProvision/seed", doctorServicesData);
            }

            // Handle doctor timings - only for selected days
            const validTimings = doctorDetails.timings
                .filter(timing => timing.scheduleDate)
                .filter(timing => {
                    // Only include timings for selected days
                    const date = new Date(timing.scheduleDate);
                    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                    const dayName = dayNames[date.getDay()];
                    return selectedDays.has(dayName);
                });

            if (validTimings.length > 0) {
                // Separate existing timings (with timingId) from new timings
                const existingTimings = validTimings.filter(timing => timing.timingId);
                const newTimings = validTimings.filter(timing => !timing.timingId);

                // Update existing timings using seedUpdate API
                if (existingTimings.length > 0) {
                    const updateTimingsData = existingTimings.map(timing => {
                        const baseData = {
                            timingId: timing.timingId,
                            doctorId: doctorId,
                            scheduleDate: timing.scheduleDate,
                            isActive: timing.isActive
                        };

                        // Add appropriate fields based on timing type
                        if (timing.startTime && timing.endTime) {
                            baseData.startTime = timing.startTime;
                            baseData.endTime = timing.endTime;
                        }
                        if (timing.unavailableStartTime && timing.unavailableEndTime) {
                            baseData.unavailableStartTime = timing.unavailableStartTime;
                            baseData.unavailableEndTime = timing.unavailableEndTime;
                        }
                        // Add reason for leave if doctor is unavailable
                        if (timing.isActive === false) {
                            baseData.Reason = timing.Reason || null;
                        }

                        return baseData;
                    });

                    await fetchData("lambdaAPI/DoctorTimings/seedUpdate", updateTimingsData);
                }

                // Create new timings using seed API
                if (newTimings.length > 0) {
                    const createTimingsData = newTimings.map(timing => {
                        const baseData = {
                            doctorId: doctorId,
                            scheduleDate: timing.scheduleDate,
                            isActive: timing.isActive
                        };

                        // Add appropriate fields based on timing type
                        if (timing.startTime && timing.endTime) {
                            baseData.startTime = timing.startTime;
                            baseData.endTime = timing.endTime;
                        }
                        if (timing.unavailableStartTime && timing.unavailableEndTime) {
                            baseData.unavailableStartTime = timing.unavailableStartTime;
                            baseData.unavailableEndTime = timing.unavailableEndTime;
                        }
                        // Add reason for leave if doctor is unavailable
                        if (timing.isActive === false) {
                            baseData.Reason = timing.Reason || null;
                        }

                        return baseData;
                    });

                    await fetchData("lambdaAPI/DoctorTimings/seed", createTimingsData);
                }
            }

            setSnackbarOpen(true);

            // Navigate back to hospital details after 2 seconds
            setTimeout(() => {
                navigate(`/hospitals/details/${hospitalId}`);
            }, 2000);

        } catch (error) {
            console.error("Error during doctor submission:", error);
            setSnackbarMessage("Submission Failed");
            setSnackbarOpen(true);
        } finally {
            setSubmitLoading(false);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbarOpen(false);
    };

    const getAvailabilityTypeColor = (type) => {
        switch (type) {
            case 'available':
                return 'success';
            case 'partial_unavailable':
                return 'warning';
            case 'unavailable':
            default:
                return 'danger';
        }
    };

    const getAvailabilityTypeLabel = (type) => {
        switch (type) {
            case 'available':
                return 'Available';
            case 'partial_unavailable':
                return 'Partially Available';
            case 'unavailable':
            default:
                return 'On Leave';
        }
    };

    if (loading) {
        return (
            <Layout>
                <PageWrapper>
                    <div className="container-fluid mt-3">
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </PageWrapper>
            </Layout>
        );
    }

    return (
        <>
            <Layout>
                <PageWrapper>
                    <div className="container-fluid mt-3">
                        <div className="row">
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div
                                        className="card-header p-3 text-white"
                                        style={{
                                            background: "linear-gradient(to right, #1976D2, #0D47A1)",
                                        }}
                                    >
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className="rounded-circle me-3 p-2 d-flex align-items-center justify-content-center"
                                                    style={{
                                                        backgroundColor: "#ECEFF1",
                                                        width: "36px",
                                                        height: "36px",
                                                    }}
                                                >
                                                    <i className="bx bx-user-plus text-primary"></i>
                                                </div>
                                                <h5 className="mb-0 fw-bold text-white">
                                                    {isEditMode ? "EDIT DOCTOR" : "ADD DOCTOR"}
                                                </h5>
                                            </div>
                                            <button
                                                className="btn btn-light btn-sm"
                                                onClick={() => navigate(`/hospitals/details/${hospitalId}`)}
                                            >
                                                <i className="bx bx-arrow-back me-1"></i>
                                                Back to Hospital
                                            </button>
                                        </div>
                                    </div>

                                    <div className="card-body p-4">
                                        <form onSubmit={onSubmitHandler}>
                                            <div className="border rounded p-4 mb-4" style={{ backgroundColor: "#f8f9fa" }}>
                                                <div className="row">
                                                    {/* Basic Doctor Information */}
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-bold mb-2 text-start w-100">
                                                            Full Name <span className="text-danger">*</span>
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text" style={{ backgroundColor: "#ECEFF1" }}>
                                                                <i className="bx bx-user text-primary"></i>
                                                            </span>
                                                            <input
                                                                type="text"
                                                                className="form-control py-2"
                                                                value={doctorDetails.FullName}
                                                                placeholder="Enter full name"
                                                                onChange={(e) => handleInputChange("FullName", e.target.value)}
                                                            />
                                                        </div>
                                                        {doctorErrors.FullName && (
                                                            <small className="text-danger">{doctorErrors.FullName}</small>
                                                        )}
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-bold mb-2 text-start w-100">
                                                            Mobile Number <span className="text-danger">*</span>
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text" style={{ backgroundColor: "#ECEFF1" }}>
                                                                <i className="bx bxs-phone text-primary"></i>
                                                            </span>
                                                            <input
                                                                type="text"
                                                                className="form-control py-2"
                                                                value={doctorDetails.MobileNumber}
                                                                maxLength={10}
                                                                placeholder="Enter mobile number"
                                                                onChange={(e) => handleInputChange("MobileNumber", e.target.value)}
                                                            />
                                                        </div>
                                                        {doctorErrors.MobileNumber && (
                                                            <small className="text-danger">{doctorErrors.MobileNumber}</small>
                                                        )}
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-bold mb-2 text-start w-100">
                                                            Date of Birth
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text" style={{ backgroundColor: "#ECEFF1" }}>
                                                                <i className="bx bx-calendar text-primary"></i>
                                                            </span>
                                                            <input
                                                                type="date"
                                                                className="form-control py-2"
                                                                value={doctorDetails.DateofBirth}
                                                                onChange={(e) => handleInputChange("DateofBirth", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-bold mb-2 text-start w-100">
                                                            Age
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text" style={{ backgroundColor: "#ECEFF1" }}>
                                                                <i className="bx bx-timer text-primary"></i>
                                                            </span>
                                                            <input
                                                                type="number"
                                                                className="form-control py-2"
                                                                value={doctorDetails.Age}
                                                                placeholder="Enter age"
                                                                onChange={(e) => handleInputChange("Age", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-bold mb-2 text-start w-100">
                                                            Qualification <span className="text-danger">*</span>
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text" style={{ backgroundColor: "#ECEFF1" }}>
                                                                <i className="bx bx-certification text-primary"></i>
                                                            </span>
                                                            <input
                                                                type="text"
                                                                className="form-control py-2"
                                                                value={doctorDetails.Qualification}
                                                                placeholder="Enter qualification"
                                                                onChange={(e) => handleInputChange("Qualification", e.target.value)}
                                                            />
                                                        </div>
                                                        {doctorErrors.Qualification && (
                                                            <small className="text-danger">{doctorErrors.Qualification}</small>
                                                        )}
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-bold mb-2 text-start w-100">
                                                            Email
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text" style={{ backgroundColor: "#ECEFF1" }}>
                                                                <i className="bx bx-envelope text-primary"></i>
                                                            </span>
                                                            <input
                                                                type="email"
                                                                className="form-control py-2"
                                                                value={doctorDetails.Email || ""}
                                                                placeholder="Enter email"
                                                                onChange={(e) => handleInputChange("Email", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label fw-bold mb-2 text-start w-100">
                                                            Address
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text" style={{ backgroundColor: "#ECEFF1" }}>
                                                                <i className="bx bx-map text-primary"></i>
                                                            </span>
                                                            <textarea
                                                                className="form-control py-2"
                                                                value={doctorDetails.Address}
                                                                placeholder="Enter address"
                                                                rows="2"
                                                                onChange={(e) => handleInputChange("Address", e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label fw-bold mb-2 text-start w-100">
                                                            Doctor Services <span className="text-danger">*</span>
                                                        </label>
                                                        <div className="select2-primary">
                                                            {doctorServices && (
                                                                <MultiSelect
                                                                    options={doctorServices}
                                                                    value={doctorDetails.Services}
                                                                    onChange={handleServiceChange}
                                                                    labelledBy="Select services"
                                                                />
                                                            )}
                                                        </div>
                                                        {doctorErrors.Services && (
                                                            <small className="text-danger">{doctorErrors.Services}</small>
                                                        )}
                                                    </div>

                                                    {/* Enhanced Schedule Management Section */}
                                                    <div className="col-md-12 mb-3">
                                                        <div className="card border-0 shadow-sm bg-white">
                                                            <div className="card-body p-4">
                                                                <h5 className="fw-bold text-dark mb-4">
                                                                    <i className="bx bx-calendar me-2 text-primary"></i>
                                                                    Doctor Schedule Management
                                                                </h5>

                                                                {/* Day Management */}
                                                                <div className="mb-4">
                                                                    <div className="card border" style={{ borderRadius: '12px', background: '#f8f9fa' }}>
                                                                        <div className="card-body p-3">
                                                                            <h6 className="fw-bold text-dark mb-3">
                                                                                <i className="bx bx-calendar me-2 text-primary"></i>
                                                                                Select Days to Configure
                                                                            </h6>

                                                                            {/* Day Selection Buttons */}
                                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                <div className="d-flex flex-wrap gap-2">
                                                                                    {daysOfWeek.map((day) => (
                                                                                        <button
                                                                                            key={day}
                                                                                            type="button"
                                                                                            onClick={() => toggleDaySelection(day)}
                                                                                            className={`btn ${selectedDays.has(day) ? 'btn-primary' : 'btn-secondary'
                                                                                                }`}
                                                                                            style={{
                                                                                                borderRadius: '8px',
                                                                                                minWidth: '100px',
                                                                                                fontWeight: selectedDays.has(day) ? 'bold' : 'normal'
                                                                                            }}
                                                                                        >
                                                                                            {selectedDays.has(day) && <i className="bx bx-check me-1"></i>}
                                                                                            {day}
                                                                                        </button>
                                                                                    ))}
                                                                                </div>
                                                                                <div>
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={selectAllDays}
                                                                                        className="btn btn-outline-primary btn-sm me-1"
                                                                                        style={{ borderRadius: '6px' }}
                                                                                    >
                                                                                        Select All
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={clearAllDays}
                                                                                        className="btn btn-outline-secondary btn-sm"
                                                                                        style={{ borderRadius: '6px' }}
                                                                                    >
                                                                                        Clear All
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <small className="text-muted">
                                                                                    <i className="bx bx-info-circle me-1"></i>
                                                                                    {selectedDays.size} day{selectedDays.size !== 1 ? 's' : ''} selected
                                                                                </small>

                                                                                {/* Quick Actions for Selected Days */}
                                                                                {selectedDays.size > 0 && (
                                                                                    <div className="d-flex gap-2">
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={makeSelectedDaysAvailable}
                                                                                            className="btn btn-success btn-sm"
                                                                                            style={{ borderRadius: '6px' }}
                                                                                        >
                                                                                            <i className="bx bx-check-circle me-1"></i>
                                                                                            Make Available
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={makeSelectedDaysUnavailable}
                                                                                            className="btn btn-danger btn-sm"
                                                                                            style={{ borderRadius: '6px' }}
                                                                                        >
                                                                                            <i className="bx bx-x-circle me-1"></i>
                                                                                            Make Leave
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Quick Time Actions */}
                                                                {selectedDays.size > 0 && (
                                                                    <div className="mb-4">
                                                                        <div className="card border" style={{ borderRadius: '12px', background: '#f8f9fa' }}>
                                                                            <div className="card-body p-3">
                                                                                <h6 className="fw-bold text-dark mb-3">
                                                                                    <i className="bx bx-time me-2 text-primary"></i>
                                                                                    Quick Time Actions
                                                                                </h6>
                                                                                <div className="row g-3 align-items-end">
                                                                                    <div className="col-md-3">
                                                                                        <label className="form-label small fw-semibold">Default Start Time</label>
                                                                                        <input
                                                                                            type="time"
                                                                                            className="form-control"
                                                                                            value={defaultTime.startTime}
                                                                                            onChange={(e) => setDefaultTime(prev => ({ ...prev, startTime: e.target.value }))}
                                                                                            style={{ borderRadius: '8px' }}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <label className="form-label small fw-semibold">Default End Time</label>
                                                                                        <input
                                                                                            type="time"
                                                                                            className="form-control"
                                                                                            value={defaultTime.endTime}
                                                                                            onChange={(e) => setDefaultTime(prev => ({ ...prev, endTime: e.target.value }))}
                                                                                            style={{ borderRadius: '8px' }}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="col-md-6">
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={applyDefaultToSelectedDays}
                                                                                            className="btn btn-primary w-100"
                                                                                            disabled={!defaultTime.startTime || !defaultTime.endTime}
                                                                                            style={{ borderRadius: '8px' }}
                                                                                        >
                                                                                            <i className="bx bx-check-double me-1"></i>
                                                                                            Apply Time to Selected Days ({selectedDays.size})
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* Day Configuration Cards - Only for Selected Days */}
                                                                {selectedDays.size > 0 && (
                                                                    <div className="mb-4">
                                                                        <label className="form-label fw-semibold text-dark mb-3">
                                                                            Configure Selected Days ({selectedDays.size} day{selectedDays.size !== 1 ? 's' : ''})
                                                                        </label>
                                                                        <div className="row g-3">
                                                                            {Array.from(selectedDays).map((day) => (
                                                                                <div key={day} className="col-md-12 col-lg-12">
                                                                                    <div className="card border-0 shadow-sm h-100">
                                                                                        <div className="card-header bg-light d-flex justify-content-between align-items-center">
                                                                                            <h6 className="fw-bold mb-0">{day}</h6>
                                                                                            <span className={`badge bg-${getAvailabilityTypeColor(weekSchedule[day].availabilityType)}`}>
                                                                                                {getAvailabilityTypeLabel(weekSchedule[day].availabilityType)}
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="card-body">
                                                                                            {/* Availability Type Selection */}
                                                                                            <div className="btn-group w-100 mb-3" role="group">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className={`btn btn-sm ${weekSchedule[day].availabilityType === 'available' ? 'btn-success' : 'btn-outline-success'}`}
                                                                                                    onClick={() => setDayAvailabilityType(day, 'available')}
                                                                                                >
                                                                                                    Available
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className={`btn btn-sm ${weekSchedule[day].availabilityType === 'partial_unavailable' ? 'btn-warning' : 'btn-outline-warning'}`}
                                                                                                    onClick={() => setDayAvailabilityType(day, 'partial_unavailable')}
                                                                                                >
                                                                                                    Partial
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className={`btn btn-sm ${weekSchedule[day].availabilityType === 'unavailable' ? 'btn-danger' : 'btn-outline-danger'}`}
                                                                                                    onClick={() => setDayAvailabilityType(day, 'unavailable')}
                                                                                                >
                                                                                                    Leave
                                                                                                </button>
                                                                                            </div>

                                                                                            {/* Available Time Slots */}
                                                                                            {(weekSchedule[day].availabilityType === 'available' || weekSchedule[day].availabilityType === 'partial_unavailable') && (
                                                                                                <div className="mb-3">
                                                                                                    <label className="form-label small fw-semibold text-muted">Available Hours</label>
                                                                                                    <div className="row g-2">
                                                                                                        <div className="col-6">
                                                                                                            <input
                                                                                                                type="time"
                                                                                                                className="form-control form-control-sm"
                                                                                                                value={weekSchedule[day].timings[0]?.startTime || ''}
                                                                                                                onChange={(e) => updateAvailableTimeSlot(day, 'startTime', e.target.value)}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="col-6">
                                                                                                            <input
                                                                                                                type="time"
                                                                                                                className="form-control form-control-sm"
                                                                                                                value={weekSchedule[day].timings[0]?.endTime || ''}
                                                                                                                onChange={(e) => updateAvailableTimeSlot(day, 'endTime', e.target.value)}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="col-12">
                                                                                                            <small className="text-muted">
                                                                                                                Duration: {calculateDuration(
                                                                                                                    weekSchedule[day].timings[0]?.startTime,
                                                                                                                    weekSchedule[day].timings[0]?.endTime
                                                                                                                )}
                                                                                                            </small>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* Unavailable Time Slots (Emergency/Break) */}
                                                                                            {weekSchedule[day].availabilityType === 'partial_unavailable' && (
                                                                                                <div className="mb-3">
                                                                                                    <label className="form-label small fw-semibold text-muted">Break Hours</label>
                                                                                                    <div className="row g-2">
                                                                                                        <div className="col-6">
                                                                                                            <input
                                                                                                                type="time"
                                                                                                                className="form-control form-control-sm border-warning"
                                                                                                                value={weekSchedule[day].unavailableTimings[0]?.startTime || ''}
                                                                                                                onChange={(e) => updateUnavailableTimeSlot(day, 'startTime', e.target.value)}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="col-6">
                                                                                                            <input
                                                                                                                type="time"
                                                                                                                className="form-control form-control-sm border-warning"
                                                                                                                value={weekSchedule[day].unavailableTimings[0]?.endTime || ''}
                                                                                                                onChange={(e) => updateUnavailableTimeSlot(day, 'endTime', e.target.value)}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="col-12">
                                                                                                            <small className="text-muted">
                                                                                                                Duration: {calculateDuration(
                                                                                                                    weekSchedule[day].unavailableTimings[0]?.startTime,
                                                                                                                    weekSchedule[day].unavailableTimings[0]?.endTime
                                                                                                                )}
                                                                                                            </small>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            {/* On Leave Message */}
                                                                                            {weekSchedule[day].availabilityType === 'unavailable' && (
                                                                                                <>

                                                                                                    <div className="mt-2">
                                                                                                        <label className="form-label small fw-semibold text-muted">Reason for Leave</label>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            className="form-control form-control-sm"
                                                                                                            value={weekSchedule[day].reason || ''}
                                                                                                            onChange={(e) => updateUnavailableReason(day, e.target.value)}
                                                                                                            placeholder="Enter reason for leave"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="alert alert-danger py-2 mb-0 mt-2">
                                                                                                        <small>
                                                                                                            <i className="bx bx-info-circle me-1"></i>
                                                                                                            Doctor is on leave
                                                                                                        </small>
                                                                                                    </div>
                                                                                                </>
                                                                                            )}

                                                                                            {/* Reset and Remove Buttons */}
                                                                                            <div className="mt-3 d-flex justify-content-between">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={() => clearDaySchedule(day)}
                                                                                                    className="btn btn-outline-secondary btn-sm"
                                                                                                >
                                                                                                    <i className="bx bx-refresh me-1"></i>
                                                                                                    Reset
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={() => toggleDaySelection(day)}
                                                                                                    className="btn btn-outline-danger btn-sm"
                                                                                                >
                                                                                                    <i className="bx bx-minus me-1"></i>
                                                                                                    Remove
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* Schedule Summary */}
                                                                <div className="mt-4">
                                                                    <div className="alert alert-info" style={{ borderRadius: '12px', border: '1px solid #bee5eb' }}>
                                                                        <h6 className="fw-bold mb-2">
                                                                            <i className="bx bx-calendar-check me-2"></i>
                                                                            Weekly Schedule Summary
                                                                        </h6>
                                                                        <div className="row g-2">
                                                                            {daysOfWeek.map(day => (
                                                                                <div key={day} className="col-md-6 col-lg-4">
                                                                                    <div className="d-flex justify-content-between align-items-center bg-white rounded p-2">
                                                                                        <div>
                                                                                            <span className="fw-medium">{day}:</span>
                                                                                            <br />
                                                                                            <small className={`text-${getAvailabilityTypeColor(weekSchedule[day].availabilityType)}`}>
                                                                                                {getAvailabilityTypeLabel(weekSchedule[day].availabilityType)}
                                                                                            </small>
                                                                                        </div>
                                                                                        <div className="text-end">
                                                                                            {weekSchedule[day].availabilityType === 'available' && weekSchedule[day].timings[0] && (
                                                                                                <span className="text-primary small">
                                                                                                    {weekSchedule[day].timings[0].startTime || '--'} - {weekSchedule[day].timings[0].endTime || '--'}
                                                                                                </span>
                                                                                            )}
                                                                                            {weekSchedule[day].availabilityType === 'partial_unavailable' && (
                                                                                                <div>
                                                                                                    {weekSchedule[day].timings[0] && (
                                                                                                        <span className="text-success small d-block">
                                                                                                            Available: {weekSchedule[day].timings[0].startTime || '--'} - {weekSchedule[day].timings[0].endTime || '--'}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    {weekSchedule[day].unavailableTimings[0] && (
                                                                                                        <span className="text-warning small d-block">
                                                                                                            Break: {weekSchedule[day].unavailableTimings[0].startTime || '--'} - {weekSchedule[day].unavailableTimings[0].endTime || '--'}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}
                                                                                            {weekSchedule[day].availabilityType === 'unavailable' && (
                                                                                                <span className="text-danger small">
                                                                                                    On Leave{weekSchedule[day].reason ? ` (${weekSchedule[day].reason})` : ''}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-between">
                                                <button
                                                    type="submit"
                                                    className="btn btn-success"
                                                    style={{ minWidth: "120px" }}
                                                    disabled={submitLoading}
                                                >
                                                    {submitLoading ? (
                                                        <div className="spinner-border spinner-border-sm text-white" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <i className="bx bx-save me-1"></i>
                                                            {isEditMode ? "Update Doctor" : "Save Doctor"}
                                                        </>
                                                    )}
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={() => navigate(`/hospitals/details/${hospitalId}`)}
                                                >
                                                    <i className="bx bx-x me-1"></i>
                                                    Cancel
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Snackbar
                            open={snackbarOpen}
                            autoHideDuration={6000}
                            onClose={handleSnackbarClose}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                            <Alert onClose={handleSnackbarClose} severity="success">
                                {snackbarMessage}
                            </Alert>
                        </Snackbar>
                    </div>
                </PageWrapper>
            </Layout>
        </>
    );
}